import { Block } from 'src/types/shared/blocks';
import { Block as BlockV3 } from 'src/types/shared/blocksV3';

function removeReface(blocks: Block[] | BlockV3[]) {
	return blocks.map((block) => ({
		...block,
		stairs: block.stairs?.map((stair) => ({
			...stair,
			reface: false,
		})),
		landings: block.landings?.map((landing) => ({
			...landing,
			reface: false,
		})),
	}));
}

export default removeReface;
